export const makeTransparent = (color: string) => `${color}24`;

export const bluePrimary = '#007BC7';
export const bluePrimaryAndBoldText = '#0090D9';
export const darkBlue = '#002337';
export const interactiveLink = '#16A7f3';

export const lightBlue = '#E3EBEF';
export const transparentBlue = '#FBFDFD';

export const darkGreenPrimary = '#008858';
export const darkGreenSecondary = '#20A878';
export const greenLightPrimary = '#6EC8B6';
export const lightGreen = '#DBF4EF';

export const lightWhite = 'rgba(255,255,255,0.1)';
export const lightWhite2 = 'rgba(255,255,255,0.2)';
export const lightGrayText = '#616969';
export const lightGrayTextSecondary = 'rgba(97,105,105,0.91)';
export const darkGrayText = 'rgba(0, 0, 0, 0.6)';

export const darkOrangePrimary = '#CC4A00';
export const darkOrangeSecondary = '#E36100';

export const darkRedAndBoldText = '#C92B40';
export const darkRedError = '#c92b40';
export const darkRedPrimary = '#C92B40';
export const darkRedValidateError = '#C92B40';
export const phoneNumbers = '#D84949';

export const backgroundColor = '#FBFDFE';
export const grey = '#8596A0';
export const white = '#FFF';
export const whiteSecondary = '#DAD9D8';
export const greyText = '#6e787a';
export const darkGrey = '#123245';

// MVP app
export const mvpBlue = '#C9E0FD';
export const mvpBlueSecondary = '#0A5EF0';
export const mvpGreenPrimary = '#E3F1E5';
export const mvpGreenSecondary = '#1D4122';
export const mvpRedPrimary = '#FFD7D4';
export const mvpRedSecondary = '#B32E30';
export const mvpYellowPrimary = '#FCF3C3';
export const mvpGrayButton = '#F6F6F4';

export const mvpGrayText = '#172A42A6';
export const mvpBlueText = '#002346';
export const mvpGreenText = '#1D4122';
export const mvpRedText = '#6A1F21';
export const mvpYellowText = '#A55705';
export const mvpGreenLogout = '#216E53';

// RealKreditDenmark website colors
export const rdRed = '#cc0000';
export const rdBlack = '#333';

/* https://css-tricks.com/converting-color-spaces-in-javascript/ */
const hexToHSL = hex => {
  // Convert hex to RGB first
  let r: any = 0,
    g: any = 0,
    b: any = 0;

  if (hex.length === 4) {
    r = '0x' + hex[1] + hex[1];
    g = '0x' + hex[2] + hex[2];
    b = '0x' + hex[3] + hex[3];
  } else if (hex.length === 7) {
    r = '0x' + hex[1] + hex[2];
    g = '0x' + hex[3] + hex[4];
    b = '0x' + hex[5] + hex[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return { h, s, l };
};

export const hexToHSLWithGradient = hex => {
  const { h, s, l } = hexToHSL(hex);

  return `linear-gradient(\
      to bottom,\
      hsla(${h}, ${s}%, ${l + 4}%, 1) 0%,\
      hsla(${h}, ${s - 2}%, ${l}%, 1) 100%\
    );`;
};

export const hexToHSLPressed = hex => {
  const { h, s, l } = hexToHSL(hex);

  return `hsla(${h}, ${s}%, ${hex === bluePrimary ? l + 2 : l + 10}%, 1);`;
};
